import React from "react";

import { HStack, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { iconColors } from "../../utils/IconColors";

export const SkillItem = (props) => {
  const { name, Icon, dabbled = false } = props;
  return (
    <motion.div
      initial="hidden"
      whileInView={"visible"}
      whileHover={{
        scale: 1.2
      }}
      variants={{
        visible: {
          y: 0,
          opacity: 1,
          transition: {
            type: "spring",
          },
        },
        hidden: { opacity: 1, y: 80 },
      }}
    >
      <HStack width={"138px"} boxShadow="md" p="1.5" rounded="md">
        <Icon color={iconColors[name.replace(" ", "").toLowerCase()]} size={45} />
        <Text color={"#fff"}>{name}</Text>
      </HStack>
    </motion.div>
  );
};
